// Utility to load and parse CSV (simple, no dependencies)
export async function loadCSV(url) {
  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`Failed to fetch CSV: ${resp.status}`);
  let text = (await resp.text()).trim();
  if (!text) return [];

  // Normalize line endings (handle CRLF)
  text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const lines = text.split('\n').filter(l => l.trim().length > 0);
  if (lines.length === 0) return [];

  // Auto-detect delimiter: check first line for common delimiters
  const firstLine = lines[0];
  const delimiters = [',', ';', '\t'];
  let delimiter = ',';
  let maxCount = -1;
  delimiters.forEach(d => {
    const count = firstLine.split(d).length;
    if (count > maxCount) {
      maxCount = count;
      delimiter = d;
    }
  });

  // Parse header
  const rawHeader = lines[0].split(delimiter);
  const firstToken = rawHeader[0]?.trim();
  const looksNumericIndex = firstToken !== '' && !Number.isNaN(Number(firstToken));
  const maybeHeaderLike = rawHeader.some(tok => /[a-zA-Z]/.test(tok));

  let keys;
  let dataLines;
  if (!looksNumericIndex || maybeHeaderLike) {
    keys = rawHeader.map(k => (k ?? '').trim());
    dataLines = lines.slice(1);
  } else {
    keys = ['Index', 'RallyID', 'player_side', 'frame', 'mid_x', 'mid_y'];
    dataLines = lines;
  }

  const normalizeRow = (rowObj) => {
    const lk = {};
    Object.keys(rowObj).forEach(k => {
      const nk = (k || '').toString().trim().toLowerCase();
      lk[nk] = (rowObj[k] || '').toString().trim();
    });

    const pick = (...names) => {
      for (const n of names) {
        const v = lk[n];
        if (v !== undefined) return v;
      }
      return undefined;
    };

    const out = {
      RallyID: pick('rallyid', 'rally_id', 'rally', 'rallyno', 'rally no', 'rally_number', 'rallynum', 'rally index'),
      player_side: pick('player_side', 'playerside', 'player side', 'side', 'player'),
      frame: pick('frame', 'frame_id', 'frame no', 'frame_number', 'fid'),
      mid_x: pick('mid_x', 'mid x', 'x', 'cx', 'center_x', 'center x'),
      mid_y: pick('mid_y', 'mid y', 'y', 'cy', 'center_y', 'center y')
    };

    if (rowObj.RallyID !== undefined) out.RallyID = rowObj.RallyID;
    if (rowObj.player_side !== undefined) out.player_side = rowObj.player_side;
    if (rowObj.frame !== undefined) out.frame = rowObj.frame;
    if (rowObj.mid_x !== undefined) out.mid_x = rowObj.mid_x;
    if (rowObj.mid_y !== undefined) out.mid_y = rowObj.mid_y;

    return out;
  };

  const rows = dataLines.map(line => {
    const vals = line.split(delimiter);
    const obj = {};
    keys.forEach((k, i) => { obj[k] = vals[i]; });
    return normalizeRow(obj);
  });

  try {
    console.debug(`[loadCSV] Parsed ${rows.length} rows from ${url}. Delimiter: "${delimiter}". Header:`, keys);
  } catch { }

  return rows;
}
